import { normalizeAll, removeWhitespaces, normalizeLowerCase } from '@widergy/web-utils/lib/normalize';
import { required, email, lengthEquals } from '@widergy/web-utils/lib/validate';

import { FIELD_TEXT, FIELD_EMAIL } from 'constants/userForms';
import { message } from 'utils/stringUtils';
import { appConfig } from 'config/customization';

export const phoneField = {
  id: 1,
  type: FIELD_TEXT,
  key: 'fieldPhone',
  order: 1,
  suborder: 1,
  title: message('Signup:phone'),
  placeholder: message('Signup:phonePlaceholder'),
  validate: [
    required(message('Validations:required')),
    lengthEquals(10, message('Validations:invalidFormat'))
  ]
};

export const emailField = {
  id: 2,
  type: FIELD_EMAIL,
  key: 'fieldEmail',
  order: 1,
  suborder: 2,
  title: message('Commons:email'),
  validate: [email(message('Validations:invalidEmail'))],
  normalize: normalizeAll([normalizeLowerCase, removeWhitespaces])
};

export const clientNumberField = {
  id: 3,
  type: FIELD_TEXT,
  key: 'fieldClientNumber',
  order: 1,
  suborder: 3,
  title: message('Accounts:clientNumberInput', { accountLength: appConfig.ACCOUNT_LENGTH }),
  placeholder: message('Accounts:clientNumberPlaceholder', { accountLength: appConfig.ACCOUNT_LENGTH }),
  validate: [lengthEquals(appConfig.ACCOUNT_LENGTH, message('Validations:invalidFormat'))]
};

export const fieldsArray = [phoneField, emailField, clientNumberField];
